import script from "./Seats.vue?vue&type=script&setup=true&lang=js"
export * from "./Seats.vue?vue&type=script&setup=true&lang=js"

import "./Seats.vue?vue&type=style&index=0&id=a663aa2c&lang=scss"

const __exports__ = script;

export default __exports__